import React, { useEffect } from "react";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { GetTeacherInformation } from "../../actions/teacherQueries";
import { fetchNotifications } from "../../actions/notificationActions";
import { useDispatch } from "react-redux";

function Teacher(props) {
  const teacherInfo = GetTeacherInformation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!teacherInfo.isLoading && teacherInfo.data) {
      dispatch(fetchNotifications());
    }
  }, [dispatch, teacherInfo.data, teacherInfo.isLoading]);

  useEffect(() => {
    if (!teacherInfo.isLoading && teacherInfo.data) {
      let firstProgram = teacherInfo.data.programmes[0];
      props.history.push(
        "/teacher/programmeview/" + firstProgram.id + "/" + firstProgram.name
      );
    }
  }, [teacherInfo.isLoading, props.history, teacherInfo.data]);

  if (teacherInfo.isLoading) {
    return <Pacmanloader />;
  }

  return null;
}

export default Teacher;
